import { Link } from "react-router-dom";

const doors = [
  {
    want: "I want to meet people.",
    body: "Enter the Human Mycelium, join the conversations and find humans who think in spirals too.",
    to: "/human-mycelium",
    cta: "Meet the mycelium",
  },
  {
    want: "I want to contribute my mind.",
    body: "Bring your thinking to a Think Tank, a project or one of the six crises we refuse to accept.",
    href: "https://octopus-thinktank.institute/",
    cta: "Contribute your mind",
  },
  {
    want: "I have a challenge.",
    body: "Tell us what is stuck. A complaint, a question or a problem nobody has been able to unlock.",
    to: "/telltom",
    cta: "Tell TOM",
  },
  {
    want: "I want to support this.",
    body: "Become a member, a partner or a donor, and keep the mycelium alive for the people who need it.",
    to: "/membership",
    cta: "Support the movement",
  },
];

const FindYourWayInSection = () => {
  return (
    <section id="find-your-way-in" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-4">Find your way in</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold">
            There is no single{" "}
            <span className="text-gradient-coral">front door.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {doors.map((door) => (
            <div
              key={door.want}
              className="group p-8 rounded-xl border-glow bg-background hover:glow-coral transition-all duration-300 hover:-translate-y-1 transform-gpu"
            >
              <h3 className="text-xl md:text-2xl font-heading font-bold mb-3 leading-snug">“{door.want}”</h3>
              <p className="text-muted-foreground leading-relaxed mb-5">{door.body}</p>
              {door.to ? (
                <Link
                  to={door.to}
                  className="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-coral-text hover:text-coral transition-colors"
                >
                  {door.cta} →
                </Link>
              ) : (
                <a
                  href={door.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-coral-text hover:text-coral transition-colors"
                >
                  {door.cta} ↗
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FindYourWayInSection;